import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

// Bottom sheet on phones, centred dialog on larger screens.
// Rendered into <body>: glass cards use backdrop-filter, which would otherwise
// trap this fixed-position sheet inside whichever card opened it.
export default function Sheet(props) {
  return createPortal(<SheetBody {...props} />, document.body);
}

function SheetBody({ title, onClose, children, testId }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center">
      <div className="absolute inset-0 bg-nest-ink/20 backdrop-blur-sm" onClick={onClose} />
      <div
        className="relative w-full md:max-w-lg max-h-[90dvh] overflow-y-auto nest-glass-strong rounded-t-3xl md:rounded-3xl p-6 nest-safe-bottom"
        data-testid={testId}
        role="dialog"
        aria-label={title}
      >
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-heading text-xl">{title}</h3>
          <button onClick={onClose} className="text-nest-faint hover:text-nest-soft" aria-label="Close">
            <X size={20} strokeWidth={1.5} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
